// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";

// function Navbar({ user: initialUser, userProfile: initialUserProfile, handleLogout }) {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [user, setUser] = useState(initialUser || null);
//   const [userProfile, setUserProfile] = useState(initialUserProfile || null);
//   const navigate = useNavigate();

//   const toggleDropdown = (menu) => {
//     setOpenDropdown(openDropdown === menu ? null : menu);
//   };

//   const getInitials = (user) => {
//     if (!user) return "";
//     if (user.firstName && user.lastName)
//       return (
//         user.firstName.charAt(0).toUpperCase() +
//         user.lastName.charAt(0).toUpperCase()
//       );
//     if (user.name)
//       return (
//         user.name.charAt(0).toUpperCase() +
//         user.name.charAt(user.name.length - 1).toUpperCase()
//       );
//     return "";
//   };

//   const handleLogoutClick = () => {
//     localStorage.removeItem("auth");
//     setUser(null);
//     setUserProfile(null);
//     if (handleLogout) handleLogout();
//     navigate("/login");
//   };

//   useEffect(() => {
//     const auth = localStorage.getItem("auth");
//     if (auth) {
//       try {
//         const parsed = JSON.parse(auth);
//         const storedUser = parsed?.user;
//         if (storedUser) {
//           setUser(storedUser);
//           setUserProfile(storedUser);
//         }
//       } catch (error) {
//         console.error("Invalid auth data:", error);
//       }
//     }
//   }, []);

//   const serviceArea = [
//     { name: "Hayes", url: "/hayes" },
//     { name: "Hunslow", url: "/hunslow" },
//     { name: "Southall", url: "/southall" },
//     { name: "Uxbridge", url: "/uxbridge" },
//     { name: "Greenford", url: "/greenford" },
//     { name: "Northolt", url: "/northolt" },
//     { name: "Windsor", url: "/windsor" },
//     { name: "Ruislip", url: "/ruislip" },
//     { name: "Harrow", url: "/harrow" },
//     { name: "Maidenhead", url: "/maidenhead" },
//     { name: "High Wycombe", url: "/highwycombe" },
//   ];

//   const aboutSection = [
//     { name: "FAQs", url: "/faq" },
//     { name: "Blog", url: "/blog" },
//     { name: "Terms & Conditions", url: "/termsandconditions" },
//   ];

//   return (
//     <nav className="w-full bg-black shadow-md fixed top-0 z-50">
//       <div className="max-w-7xl mx-auto flex justify-between items-center px-4 sm:px-6 md:px-8 py-3 md:py-4">
//         {/* ---------- Logo ---------- */}
//         <Link to="/" className="flex items-center space-x-2">
//           <img
//             src="/images/Logo.jpg"
//             alt="Logo"
//             className="w-10 h-10 sm:w-12 sm:h-12 md:w-[70px] md:h-[70px] rounded-full border-2 border-orange-600 object-cover"
//           />
//           <span className="font-bold text-lg sm:text-xl text-orange-500">
//             MFCB
//           </span>
//         </Link>

//         {/* ---------- Desktop Menu ---------- */}
//         <ul className="hidden md:flex space-x-8 items-center mx-auto">
//           <li>
//             <Link
//               to="/"
//               className="text-gray-300 hover:text-orange-500 font-medium"
//             >
//               Home
//             </Link>
//           </li>

//           {/* Services Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("services")}
//               className="text-gray-300 hover:text-orange-500 font-medium flex items-center"
//             >
//               Service Areas
//               <svg
//                 className="ml-1 w-4 h-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M19 9l-7 7-7-7"
//                 />
//               </svg>
//             </button>
//             {openDropdown === "services" && (
//               <ul className="absolute top-10 left-0 bg-black border border-gray-700 shadow-md rounded-md w-44 z-50">
//                 {serviceArea.map((item, idx) => (
//                   <li key={idx}>
//                     <Link
//                       to={item.url}
//                       className="block px-4 py-2 text-sm text-gray-300 hover:bg-orange-600 hover:text-white"
//                     >
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </li>

//           {/* About Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("about")}
//               className="text-gray-300 hover:text-orange-500 font-medium flex items-center"
//             >
//               About
//               <svg
//                 className="ml-1 w-4 h-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M19 9l-7 7-7-7"
//                 />
//               </svg>
//             </button>
//             {openDropdown === "about" && (
//               <ul className="absolute top-10 left-0 bg-black border border-gray-700 shadow-md rounded-md w-44 z-50">
//                 {aboutSection.map((item, idx) => (
//                   <li key={idx}>
//                     <Link
//                       to={item.url}
//                       className="block px-4 py-2 text-sm text-gray-300 hover:bg-orange-600 hover:text-white"
//                     >
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </li>

//           {/* Client Portal Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("client")}
//               className="text-gray-300 hover:text-orange-500 font-medium flex items-center"
//             >
//               Client Portal
//               <svg
//                 className="ml-1 w-4 h-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M19 9l-7 7-7-7"
//                 />
//               </svg>
//             </button>
//             {openDropdown === "client" && (
//               <ul className="absolute top-10 left-0 bg-black border border-gray-700 shadow-md rounded-md w-44 z-50">
//                 {user ? (
//                   <>
//                     {userProfile?.role === "user" && (
//                       <li>
//                         <Link
//                           to="/book"
//                           className="block px-4 py-2 text-sm text-gray-300 hover:bg-orange-600 hover:text-white"
//                         >
//                           Book Now
//                         </Link>
//                       </li>
//                     )}
//                     <li>
//                       <button
//                         onClick={handleLogoutClick}
//                         className="w-full text-left px-4 py-2 text-sm text-gray-300 hover:bg-orange-600 hover:text-white"
//                       >
//                         Logout
//                       </button>
//                     </li>
//                   </>
//                 ) : (
//                   <>
//                     <li>
//                       <Link
//                         to="/login"
//                         className="block px-4 py-2 text-sm text-gray-300 hover:bg-orange-600 hover:text-white"
//                       >
//                         Login
//                       </Link>
//                     </li>
//                     <li>
//                       <Link
//                         to="/register"
//                         className="block px-4 py-2 text-sm text-gray-300 hover:bg-orange-600 hover:text-white"
//                       >
//                         Register
//                       </Link>
//                     </li>
//                   </>
//                 )}
//               </ul>
//             )}
//           </li>

//           <li>
//             <Link
//               to="/contact"
//               className="text-gray-300 hover:text-orange-500 font-medium"
//             >
//               Contact Us
//             </Link>
//           </li>
//         </ul>

//         {/* ---------- Right Side (Profile / Buttons) ---------- */}
//         <div className="flex items-center space-x-3 sm:space-x-4">
//           {user ? (
//             <Link to="/profile" className="flex items-center justify-center">
//               {userProfile?.avtar ? (
//                 <img
//                   src={userProfile.avtar}
//                   alt="Profile"
//                   className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border-2 border-orange-600 object-cover"
//                 />
//               ) : (
//                 <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border-2 border-orange-600 bg-orange-700 text-white font-bold text-sm sm:text-base">
//                   {getInitials(userProfile || user)}
//                 </div>
//               )}
//             </Link>
//           ) : (
//             <>
//               <Link
//                 to="/login"
//                 className="px-2.5 py-1.5 sm:px-3 sm:py-1.5 md:px-4 md:py-2 text-sm sm:text-base rounded-md text-orange-500 border border-orange-600 hover:bg-orange-600 hover:text-white transition-all"
//               >
//                 Login
//               </Link>
//               <Link
//                 to="/register"
//                 className="px-2.5 py-1.5 sm:px-3 sm:py-1.5 md:px-4 md:py-2 text-sm sm:text-base rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-all"
//               >
//                 Signup
//               </Link>
//             </>
//           )}
//         </div>

//         {/* ---------- Mobile Menu Button ---------- */}
//         <button
//           onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//           className="md:hidden text-orange-500 focus:outline-none ml-2"
//         >
//           <svg
//             className="w-8 h-8"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M4 6h16M4 12h16m-7 6h7"
//             />
//           </svg>
//         </button>
//       </div>

//       {/* ---------- Mobile Menu ---------- */}
//       {isMobileMenuOpen && (
//         <div className="md:hidden bg-black text-gray-300 flex flex-col px-6 py-4 space-y-3 text-sm">
//           <Link
//             to="/"
//             className="hover:text-orange-500"
//             onClick={() => setIsMobileMenuOpen(false)}
//           >
//             Home
//           </Link>
//           <details>
//             <summary className="cursor-pointer hover:text-orange-500">
//               Service Areas
//             </summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {serviceArea.map((item, idx) => (
//                 <li key={idx}>
//                   <Link
//                     to={item.url}
//                     onClick={() => setIsMobileMenuOpen(false)}
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </details>

//           <details>
//             <summary className="cursor-pointer hover:text-orange-500">
//               About
//             </summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {aboutSection.map((item, idx) => (
//                 <li key={idx}>
//                   <Link
//                     to={item.url}
//                     onClick={() => setIsMobileMenuOpen(false)}
//                   >
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </details>

//           <details>
//             <summary className="cursor-pointer hover:text-orange-500">
//               Client Portal
//             </summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {user ? (
//                 <>
//                   {userProfile?.role === "user" && (
//                     <li>
//                       <Link
//                         to="/book"
//                         onClick={() => setIsMobileMenuOpen(false)}
//                       >
//                         Book Now
//                       </Link>
//                     </li>
//                   )}
//                   <li>
//                     <button onClick={handleLogoutClick}>Logout</button>
//                   </li>
//                 </>
//               ) : (
//                 <>
//                   <li>
//                     <Link
//                       to="/login"
//                       onClick={() => setIsMobileMenuOpen(false)}
//                     >
//                       Login
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="/register"
//                       onClick={() => setIsMobileMenuOpen(false)}
//                     >
//                       Register
//                     </Link>
//                   </li>
//                 </>
//               )}
//             </ul>
//           </details>

//           <Link
//             to="/contact"
//             className="hover:text-orange-500"
//             onClick={() => setIsMobileMenuOpen(false)}
//           >
//             Contact Us
//           </Link>
//         </div>
//       )}
//     </nav>
//   );
// }

// export default Navbar;


//******* *

// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";

// function Navbar({ user: initialUser, userProfile: initialUserProfile, handleLogout }) {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [user, setUser] = useState(initialUser || null);
//   const [userProfile, setUserProfile] = useState(initialUserProfile || null);
//   const navigate = useNavigate();

//   const toggleDropdown = (menu) => {
//     setOpenDropdown(openDropdown === menu ? null : menu);
//   };

//   const getInitials = (user) => {
//     if (!user) return "";
//     if (user.firstName && user.lastName)
//       return user.firstName.charAt(0).toUpperCase() + user.lastName.charAt(0).toUpperCase();
//     if (user.name)
//       return user.name.charAt(0).toUpperCase() + user.name.charAt(user.name.length - 1).toUpperCase();
//     return "";
//   };

//   const handleLogoutClick = () => {
//     localStorage.removeItem("auth");
//     setUser(null);
//     setUserProfile(null);
//     if (handleLogout) handleLogout();
//     navigate("/login");
//   };

//   useEffect(() => {
//     const auth = localStorage.getItem("auth");
//     if (auth) {
//       try {
//         const parsed = JSON.parse(auth);
//         const storedUser = parsed?.user;
//         if (storedUser) {
//           setUser(storedUser);
//           setUserProfile(storedUser);
//         }
//       } catch (error) {
//         console.error("Invalid auth data:", error);
//       }
//     }
//   }, []);

//   const serviceArea = [
//     { name: "Hayes", url: "/hayes" },
//     { name: "Hunslow", url: "/hunslow" },
//     { name: "Southall", url: "/southall" },
//     { name: "Uxbridge", url: "/uxbridge" },
//     { name: "Greenford", url: "/greenford" },
//     { name: "Northolt", url: "/northolt" },
//     { name: "Windsor", url: "/windsor" },
//     { name: "Ruislip", url: "/ruislip" },
//     { name: "Harrow", url: "/harrow" },
//     { name: "Maidenhead", url: "/maidenhead" },
//     { name: "High Wycombe", url: "/highwycombe" },
//   ];

//   const aboutSection = [
//     { name: "FAQs", url: "/faq" },
//     { name: "Blog", url: "/blog" },
//     { name: "Terms & Conditions", url: "/termsandconditions" },
//   ];

//   return (
//     <nav className="w-full bg-green-900 shadow-md fixed top-0 z-50">
//       <div className="max-w-7xl mx-auto flex justify-between items-center px-4 sm:px-6 md:px-8 py-3 md:py-4">
//         {/* ---------- Logo ---------- */}
//         <Link to="/" className="flex items-center space-x-2">
//           <img
//             src="/images/Logo.jpg"
//             alt="Logo"
//             className="w-10 h-10 sm:w-12 sm:h-12 md:w-[70px] md:h-[70px] rounded-full border-2 border-yellow-400 object-cover"
//           />
//           <span className="font-bold text-lg sm:text-xl text-yellow-400">MFCB</span>
//         </Link>

//         {/* ---------- Desktop Menu ---------- */}
//         <ul className="hidden md:flex space-x-8 items-center mx-auto">
//           <li>
//             <Link
//               to="/"
//               className="text-white font-medium hover:text-yellow-400 transition-all duration-300"
//             >
//               Home
//             </Link>
//           </li>

//           {/* Services Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("services")}
//               className="text-white font-medium flex items-center hover:text-yellow-400 transition-all duration-300"
//             >
//               Service Areas
//               <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//               </svg>
//             </button>
//             {openDropdown === "services" && (
//               <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-400 shadow-lg rounded-md w-44 z-50">
//                 {serviceArea.map((item, idx) => (
//                   <li key={idx}>
//                     <Link
//                       to={item.url}
//                       className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                     >
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </li>

//           {/* About Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("about")}
//               className="text-white font-medium flex items-center hover:text-yellow-400 transition-all duration-300"
//             >
//               About
//               <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//               </svg>
//             </button>
//             {openDropdown === "about" && (
//               <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-400 shadow-lg rounded-md w-44 z-50">
//                 {aboutSection.map((item, idx) => (
//                   <li key={idx}>
//                     <Link
//                       to={item.url}
//                       className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                     >
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </li>

//           {/* Client Portal Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("client")}
//               className="text-white font-medium flex items-center hover:text-yellow-400 transition-all duration-300"
//             >
//               Client Portal
//               <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//               </svg>
//             </button>
//             {openDropdown === "client" && (
//               <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-400 shadow-lg rounded-md w-44 z-50">
//                 {user ? (
//                   <>
//                     {userProfile?.role === "user" && (
//                       <li>
//                         <Link
//                           to="/book"
//                           className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                         >
//                           Book Now
//                         </Link>
//                       </li>
//                     )}
//                     <li>
//                       <button
//                         onClick={handleLogoutClick}
//                         className="w-full text-left px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                       >
//                         Logout
//                       </button>
//                     </li>
//                   </>
//                 ) : (
//                   <>
//                     <li>
//                       <Link
//                         to="/login"
//                         className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                       >
//                         Login
//                       </Link>
//                     </li>
//                     <li>
//                       <Link
//                         to="/register"
//                         className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                       >
//                         Register
//                       </Link>
//                     </li>
//                   </>
//                 )}
//               </ul>
//             )}
//           </li>

//           <li>
//             <Link
//               to="/contact"
//               className="text-white font-medium hover:text-yellow-400 transition-all duration-300"
//             >
//               Contact Us
//             </Link>
//           </li>
//         </ul>

//         {/* ---------- Right Side (Profile / Buttons) ---------- */}
//         <div className="flex items-center space-x-3 sm:space-x-4">
//           {user ? (
//             <Link to="/profile" className="flex items-center justify-center">
//               {userProfile?.avtar ? (
//                 <img
//                   src={userProfile.avtar}
//                   alt="Profile"
//                   className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border-2 border-yellow-400 object-cover"
//                 />
//               ) : (
//                 <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border-2 border-yellow-400 bg-yellow-600 text-green-900 font-bold text-sm sm:text-base">
//                   {getInitials(userProfile || user)}
//                 </div>
//               )}
//             </Link>
//           ) : (
//             <>
//               <Link
//                 to="/login"
//                 className="px-3 py-1.5 text-sm sm:text-base rounded-md text-yellow-400 border border-yellow-400 hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//               >
//                 Login
//               </Link>
//               <Link
//                 to="/register"
//                 className="px-3 py-1.5 text-sm sm:text-base rounded-md bg-yellow-400 text-green-900 hover:bg-yellow-300 hover:text-white transition-all duration-300"
//               >
//                 Signup
//               </Link>
//             </>
//           )}
//         </div>

//         {/* ---------- Mobile Menu Button ---------- */}
//         <button
//           onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//           className="md:hidden text-yellow-400 focus:outline-none ml-2"
//         >
//           <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
//           </svg>
//         </button>
//       </div>

//       {/* ---------- Mobile Menu ---------- */}
//       {isMobileMenuOpen && (
//         <div className="md:hidden bg-green-900 text-white flex flex-col px-6 py-4 space-y-3 text-sm">
//           <Link to="/" className="hover:text-yellow-400" onClick={() => setIsMobileMenuOpen(false)}>
//             Home
//           </Link>
//           <details>
//             <summary className="cursor-pointer hover:text-yellow-400">Service Areas</summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {serviceArea.map((item, idx) => (
//                 <li key={idx}>
//                   <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)} className="hover:text-yellow-400">
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </details>
//           <details>
//             <summary className="cursor-pointer hover:text-yellow-400">About</summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {aboutSection.map((item, idx) => (
//                 <li key={idx}>
//                   <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)} className="hover:text-yellow-400">
//                     {item.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </details>
//           <details>
//             <summary className="cursor-pointer hover:text-yellow-400">Client Portal</summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {user ? (
//                 <>
//                   {userProfile?.role === "user" && (
//                     <li>
//                       <Link to="/book" onClick={() => setIsMobileMenuOpen(false)} className="hover:text-yellow-400">
//                         Book Now
//                       </Link>
//                     </li>
//                   )}
//                   <li>
//                     <button onClick={handleLogoutClick} className="hover:text-yellow-400">Logout</button>
//                   </li>
//                 </>
//               ) : (
//                 <>
//                   <li>
//                     <Link to="/login" onClick={() => setIsMobileMenuOpen(false)} className="hover:text-yellow-400">
//                       Login
//                     </Link>
//                   </li>
//                   <li>
//                     <Link to="/register" onClick={() => setIsMobileMenuOpen(false)} className="hover:text-yellow-400">
//                       Register
//                     </Link>
//                   </li>
//                 </>
//               )}
//             </ul>
//           </details>
//           <Link to="/contact" className="hover:text-yellow-400" onClick={() => setIsMobileMenuOpen(false)}>
//             Contact Us
//           </Link>
//         </div>
//       )}
//     </nav>
//   );
// }

// export default Navbar;

// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";

// function Navbar({ user: initialUser, userProfile: initialUserProfile, handleLogout }) {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [user, setUser] = useState(initialUser || null);
//   const [userProfile, setUserProfile] = useState(initialUserProfile || null);
//   const navigate = useNavigate();

//   const toggleDropdown = (menu) => {
//     setOpenDropdown(openDropdown === menu ? null : menu);
//   };

//   const getInitials = (user) => {
//     if (!user) return "";
//     if (user.firstName && user.lastName)
//       return (
//         user.firstName.charAt(0).toUpperCase() +
//         user.lastName.charAt(0).toUpperCase()
//       );
//     if (user.name)
//       return (
//         user.name.charAt(0).toUpperCase() +
//         user.name.charAt(user.name.length - 1).toUpperCase()
//       );
//     return "";
//   };

//   const handleLogoutClick = () => {
//     localStorage.removeItem("auth");
//     setUser(null);
//     setUserProfile(null);
//     if (handleLogout) handleLogout();
//     navigate("/login");
//   };

//   useEffect(() => {
//     const auth = localStorage.getItem("auth");
//     if (auth) {
//       try {
//         const parsed = JSON.parse(auth);
//         const storedUser = parsed?.user;
//         if (storedUser) {
//           setUser(storedUser);
//           setUserProfile(storedUser);
//         }
//       } catch (error) {
//         console.error("Invalid auth data:", error);
//       }
//     }
//   }, []);

//   const serviceArea = [
//     { name: "Hayes", url: "/hayes" },
//     { name: "Hunslow", url: "/hunslow" },
//     { name: "Southall", url: "/southall" },
//     { name: "Uxbridge", url: "/uxbridge" },
//     { name: "Greenford", url: "/greenford" },
//     { name: "Northolt", url: "/northolt" },
//     { name: "Windsor", url: "/windsor" },
//     { name: "Ruislip", url: "/ruislip" },
//     { name: "Harrow", url: "/harrow" },
//     { name: "Maidenhead", url: "/maidenhead" },
//     { name: "High Wycombe", url: "/highwycombe" },
//   ];

//   const aboutSection = [
//     { name: "FAQs", url: "/faq" },
//     { name: "Blog", url: "/blog" },
//     { name: "Terms & Conditions", url: "/termsandconditions" },
//   ];

//   const products = [
//     { name: "Blinds", url: "/products/blinds" },
//     { name: "Carpets", url: "/products/carpets" },
//     { name: "Furniture", url: "/products/furniture" },
//     { name: "Bundles", url: "/products/bundles" },
//   ];

//   return (
//     <nav className="w-full bg-green-900 shadow-md fixed top-0 z-50">
//       <div className="max-w-7xl mx-auto flex justify-between items-center px-4 sm:px-6 md:px-8 py-3 md:py-4">
//         {/* ---------- Logo ---------- */}
//         <Link to="/" className="flex items-center space-x-2">
//           <img
//             src="/images/Logo.jpg"
//             alt="Logo"
//             className="w-10 h-10 sm:w-12 sm:h-12 md:w-[70px] md:h-[70px] rounded-full border-2 border-yellow-500 object-cover"
//           />
//           <span className="font-bold text-lg sm:text-xl text-yellow-500">
//             MFCB
//           </span>
//         </Link>

//         {/* ---------- Desktop Menu ---------- */}
//         <ul className="hidden md:flex space-x-8 items-center mx-auto">
//           <li>
//             <Link
//               to="/"
//               className="text-white hover:text-yellow-400 font-medium transition-all duration-300"
//             >
//               Home
//             </Link>
//           </li>

//           {/* Service Areas Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("services")}
//               className="text-white hover:text-yellow-400 font-medium flex items-center transition-all duration-300"
//             >
//               Service Areas
//               <svg
//                 className="ml-1 w-4 h-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M19 9l-7 7-7-7"
//                 />
//               </svg>
//             </button>
//             {openDropdown === "services" && (
//               <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-500 shadow-lg rounded-md w-44 z-50">
//                 {serviceArea.map((item, idx) => (
//                   <li key={idx}>
//                     <Link
//                       to={item.url}
//                       className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                     >
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </li>

//           {/* Products Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("products")}
//               className="text-white hover:text-yellow-400 font-medium flex items-center transition-all duration-300"
//             >
//               Products
//               <svg
//                 className="ml-1 w-4 h-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M19 9l-7 7-7-7"
//                 />
//               </svg>
//             </button>
//             {openDropdown === "products" && (
//               <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-500 shadow-lg rounded-md w-44 z-50">
//                 {products.map((item, idx) => (
//                   <li key={idx}>
//                     <Link
//                       to={item.url}
//                       className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                     >
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </li>

//           {/* About Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("about")}
//               className="text-white hover:text-yellow-400 font-medium flex items-center transition-all duration-300"
//             >
//               About
//               <svg
//                 className="ml-1 w-4 h-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M19 9l-7 7-7-7"
//                 />
//               </svg>
//             </button>
//             {openDropdown === "about" && (
//               <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-500 shadow-lg rounded-md w-44 z-50">
//                 {aboutSection.map((item, idx) => (
//                   <li key={idx}>
//                     <Link
//                       to={item.url}
//                       className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                     >
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </li>

//           {/* Client Portal Dropdown */}
//           <li className="relative">
//             <button
//               onClick={() => toggleDropdown("client")}
//               className="text-white hover:text-yellow-400 font-medium flex items-center transition-all duration-300"
//             >
//               Client Portal
//               <svg
//                 className="ml-1 w-4 h-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M19 9l-7 7-7-7"
//                 />
//               </svg>
//             </button>
//             {openDropdown === "client" && (
//               <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-500 shadow-lg rounded-md w-44 z-50">
//                 {user ? (
//                   <>
//                     {userProfile?.role === "user" && (
//                       <li>
//                         <Link
//                           to="/book"
//                           className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                         >
//                           Book Now
//                         </Link>
//                       </li>
//                     )}
//                     <li>
//                       <button
//                         onClick={handleLogoutClick}
//                         className="w-full text-left px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                       >
//                         Logout
//                       </button>
//                     </li>
//                   </>
//                 ) : (
//                   <>
//                     <li>
//                       <Link
//                         to="/login"
//                         className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                       >
//                         Login
//                       </Link>
//                     </li>
//                     <li>
//                       <Link
//                         to="/register"
//                         className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                       >
//                         Register
//                       </Link>
//                     </li>
//                   </>
//                 )}
//               </ul>
//             )}
//           </li>

//           <li>
//             <Link
//               to="/contact"
//               className="text-white hover:text-yellow-400 font-medium transition-all duration-300"
//             >
//               Contact Us
//             </Link>
//           </li>
//         </ul>

//         {/* ---------- Right Side (Profile / Buttons) ---------- */}
//         <div className="flex items-center space-x-3 sm:space-x-4">
//           {user ? (
//             <Link to="/profile" className="flex items-center justify-center">
//               {userProfile?.avtar ? (
//                 <img
//                   src={userProfile.avtar}
//                   alt="Profile"
//                   className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border-2 border-yellow-500 object-cover"
//                 />
//               ) : (
//                 <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border-2 border-yellow-500 bg-yellow-700 text-white font-bold text-sm sm:text-base">
//                   {getInitials(userProfile || user)}
//                 </div>
//               )}
//             </Link>
//           ) : (
//             <>
//               <Link
//                 to="/login"
//                 className="px-4 py-2 text-sm sm:text-base rounded-md text-yellow-500 border border-yellow-500 hover:bg-yellow-500 hover:text-green-900 transition-all duration-300"
//               >
//                 Login
//               </Link>
//               <Link
//                 to="/register"
//                 className="px-4 py-2 text-sm sm:text-base rounded-md bg-yellow-500 text-green-900 hover:bg-yellow-400 transition-all duration-300"
//               >
//                 Signup
//               </Link>
//             </>
//           )}
//         </div>

//         {/* ---------- Mobile Menu Button ---------- */}
//         <button
//           onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//           className="md:hidden text-yellow-500 focus:outline-none ml-2"
//         >
//           <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
//           </svg>
//         </button>
//       </div>

//       {/* ---------- Mobile Menu ---------- */}
//       {isMobileMenuOpen && (
//         <div className="md:hidden bg-green-900 text-white flex flex-col px-6 py-4 space-y-3 text-sm">
//           <Link to="/" className="hover:text-yellow-400" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>

//           {/* Service Areas */}
//           <details>
//             <summary className="cursor-pointer hover:text-yellow-400">Service Areas</summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {serviceArea.map((item, idx) => (
//                 <li key={idx}>
//                   <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)}>{item.name}</Link>
//                 </li>
//               ))}
//             </ul>
//           </details>

//           {/* Products */}
//           <details>
//             <summary className="cursor-pointer hover:text-yellow-400">Products</summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {products.map((item, idx) => (
//                 <li key={idx}>
//                   <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)}>{item.name}</Link>
//                 </li>
//               ))}
//             </ul>
//           </details>

//           {/* About */}
//           <details>
//             <summary className="cursor-pointer hover:text-yellow-400">About</summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {aboutSection.map((item, idx) => (
//                 <li key={idx}>
//                   <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)}>{item.name}</Link>
//                 </li>
//               ))}
//             </ul>
//           </details>

//           {/* Client Portal */}
//           <details>
//             <summary className="cursor-pointer hover:text-yellow-400">Client Portal</summary>
//             <ul className="ml-4 mt-2 space-y-2">
//               {user ? (
//                 <>
//                   {userProfile?.role === "user" && (
//                     <li>
//                       <Link to="/book" onClick={() => setIsMobileMenuOpen(false)}>Book Now</Link>
//                     </li>
//                   )}
//                   <li>
//                     <button onClick={handleLogoutClick}>Logout</button>
//                   </li>
//                 </>
//               ) : (
//                 <>
//                   <li>
//                     <Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>Login</Link>
//                   </li>
//                   <li>
//                     <Link to="/register" onClick={() => setIsMobileMenuOpen(false)}>Register</Link>
//                   </li>
//                 </>
//               )}
//             </ul>
//           </details>

//           <Link to="/contact" className="hover:text-yellow-400" onClick={() => setIsMobileMenuOpen(false)}>Contact Us</Link>
//         </div>
//       )}
//     </nav>
//   );
// }

// export default Navbar;

// green attempy
// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";

// function Navbar({ user: initialUser, userProfile: initialUserProfile, handleLogout }) {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [user, setUser] = useState(initialUser || null);
//   const [userProfile, setUserProfile] = useState(initialUserProfile || null);
//   const navigate = useNavigate();

//   const toggleDropdown = (menu) => {
//     setOpenDropdown(openDropdown === menu ? null : menu);
//   };

//   const getInitials = (user) => {
//     if (!user) return "";
//     if (user.firstName && user.lastName)
//       return (
//         user.firstName.charAt(0).toUpperCase() +
//         user.lastName.charAt(0).toUpperCase()
//       );
//     if (user.name)
//       return (
//         user.name.charAt(0).toUpperCase() +
//         user.name.charAt(user.name.length - 1).toUpperCase()
//       );
//     return "";
//   };

//   const handleLogoutClick = () => {
//     localStorage.removeItem("auth");
//     setUser(null);
//     setUserProfile(null);
//     if (handleLogout) handleLogout();
//     navigate("/login");
//   };

//   useEffect(() => {
//     const auth = localStorage.getItem("auth");
//     if (auth) {
//       try {
//         const parsed = JSON.parse(auth);
//         const storedUser = parsed?.user;
//         if (storedUser) {
//           setUser(storedUser);
//           setUserProfile(storedUser);
//         }
//       } catch (error) {
//         console.error("Invalid auth data:", error);
//       }
//     }
//   }, []);

//   const serviceArea = [
//     { name: "Hayes", url: "/hayes" },
//     { name: "Hunslow", url: "/hunslow" },
//     { name: "Southall", url: "/southall" },
//     { name: "Uxbridge", url: "/uxbridge" },
//     { name: "Greenford", url: "/greenford" },
//     { name: "Northolt", url: "/northolt" },
//     { name: "Windsor", url: "/windsor" },
//     { name: "Ruislip", url: "/ruislip" },
//     { name: "Harrow", url: "/harrow" },
//     { name: "Maidenhead", url: "/maidenhead" },
//     { name: "High Wycombe", url: "/highwycombe" },
//   ];

//   const aboutSection = [
//     { name: "FAQs", url: "/faq" },
//     { name: "Blog", url: "/blog" },
//     { name: "Terms & Conditions", url: "/termsandconditions" },
//   ];

//   const products = [
//     { name: "Blinds", url: "/blinds" },
//     { name: "Carpets", url: "/carpets" },
//     { name: "Furniture", url: "/furniture" },
//     { name: "Sofa", url: "/sofa" },
//   ];

//   return (
//     <>
//       {/* ---------- Top Bar ---------- */}
//       <div className="w-full text-black mt-2 py-2 px-4 sm:px-8 flex justify-between items-center text-sm sm:text-base font-semibold tracking-wide">
//         <a
//           href="https://wa.me/447405264139"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="hover:text-green-700 transition-all"
//         >
//           📞 +44 7405 264139
//         </a>

//         <span>🏠 Serving Greater London Area</span>
//       </div>

//       {/* ---------- Navbar ---------- */}
//       <nav className="w-full bg-green-900 shadow-md sticky top-0 z-50">
//         <div className="max-w-7xl mx-auto flex justify-between items-center px-4 sm:px-4 md:px-6 py-3 md:py-4">

//           {/* Logo */}
//        <Link to="/" className="flex items-center space-x-3">
//   {/* Logo Image */}
//   <div className="w-14 h-14 md:w-16 md:h-16 relative">
//     <img
//       src="/images/111.jpg"
//       alt="Logo"
//       className="w-full h-full rounded-full border-2 border-yellow-500 object-cover shadow-md"
//     />
//     {/* Optional: subtle glow / highlight */}
//     <div className="absolute inset-0 rounded-full ring-2 ring-yellow-400 opacity-20"></div>
//   </div>

//   {/* Brand Name */}
//   <span className="font-extrabold text-lg sm:text-2xl md:text-3xl text-yellow-500 tracking-wider drop-shadow-md">
//     MF Blind
//   </span>
// </Link>


//           {/* ---------- Desktop Menu ---------- */}
//           <ul className="hidden md:flex space-x-8 items-center mx-auto">
//             <li>
//               <Link to="/" className="text-white hover:text-yellow-400 font-medium transition-all duration-300">
//                 Home
//               </Link>
//             </li>

//             {/* Service Areas Dropdown */}
//             <li className="relative">
//               <button
//                 onClick={() => toggleDropdown("services")}
//                 className="text-white hover:text-yellow-400 font-medium flex items-center transition-all duration-300"
//               >
//                 Service Areas
//                 <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                 </svg>
//               </button>

//               {openDropdown === "services" && (
//                 <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-500 shadow-lg rounded-md w-44 z-50">
//                   {serviceArea.map((item, idx) => (
//                     <li key={idx}>
//                       <Link
//                         to={item.url}
//                         className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                       >
//                         {item.name}
//                       </Link>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </li>

//             {/* Products Dropdown */}
//             <li className="relative">
//               <button
//                 onClick={() => toggleDropdown("products")}
//                 className="text-white hover:text-yellow-400 font-medium flex items-center transition-all duration-300"
//               >
//                 Products
//                 <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                 </svg>
//               </button>

//               {openDropdown === "products" && (
//                 <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-500 shadow-lg rounded-md w-44 z-50">
//                   {products.map((item, idx) => (
//                     <li key={idx}>
//                       <Link
//                         to={item.url}
//                         className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                       >
//                         {item.name}
//                       </Link>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </li>

//             {/* About Dropdown */}
//             <li className="relative">
//               <button
//                 onClick={() => toggleDropdown("about")}
//                 className="text-white hover:text-yellow-400 font-medium flex items-center transition-all duration-300"
//               >
//                 About
//                 <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                 </svg>
//               </button>

//               {openDropdown === "about" && (
//                 <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-500 shadow-lg rounded-md w-44 z-50">
//                   {aboutSection.map((item, idx) => (
//                     <li key={idx}>
//                       <Link
//                         to={item.url}
//                         className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                       >
//                         {item.name}
//                       </Link>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </li>

//             {/* Client Portal */}
//             <li className="relative">
//               <button
//                 onClick={() => toggleDropdown("client")}
//                 className="text-white hover:text-yellow-400 font-medium flex items-center transition-all duration-300"
//               >
//                 Client Portal
//                 <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                 </svg>
//               </button>

//               {openDropdown === "client" && (
//                 <ul className="absolute top-10 left-0 bg-green-900 border border-yellow-500 shadow-lg rounded-md w-44 z-50">
//                   {user ? (
//                     <>
//                       {userProfile?.role === "user" && (
//                         <li>
//                           <Link
//                             to="/book"
//                             className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                           >
//                             Book Now
//                           </Link>
//                         </li>
//                       )}
//                       <li>
//                         <button
//                           onClick={handleLogoutClick}
//                           className="w-full text-left px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                         >
//                           Logout
//                         </button>
//                       </li>
//                     </>
//                   ) : (
//                     <>
//                       <li>
//                         <Link
//                           to="/login"
//                           className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                         >
//                           Login
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           to="/register"
//                           className="block px-4 py-2 text-sm text-white hover:bg-yellow-400 hover:text-green-900 transition-all duration-300"
//                         >
//                           Register
//                         </Link>
//                       </li>
//                     </>
//                   )}
//                 </ul>
//               )}
//             </li>

//             <li>
//               <Link
//                 to="/contact"
//                 className="text-white hover:text-yellow-400 font-medium transition-all duration-300"
//               >
//                 Contact Us
//               </Link>
//             </li>
//           </ul>

//           {/* ---------- Right Side (Login / Profile Buttons) ---------- */}
//           <div className="flex items-center space-x-3 sm:space-x-4">
//             {user ? (
//               <Link to="/profile" className="flex items-center justify-center">
//                 {userProfile?.avtar ? (
//                   <img
//                     src={userProfile.avtar}
//                     alt="Profile"
//                     className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border-2 border-yellow-500 object-cover"
//                   />
//                 ) : (
//                   <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border-2 border-yellow-500 bg-yellow-700 text-white font-bold text-sm sm:text-base">
//                     {getInitials(userProfile || user)}
//                   </div>
//                 )}
//               </Link>
//             ) : (
//               <>
//                 <Link
//                   to="/login"
//                   className="px-4 py-2 text-sm sm:text-base rounded-md text-yellow-500 border border-yellow-500 hover:bg-yellow-500 hover:text-green-900 transition-all duration-300"
//                 >
//                   Login
//                 </Link>
//                 <Link
//                   to="/register"
//                   className="px-4 py-2 text-sm sm:text-base rounded-md bg-yellow-500 text-green-900 hover:bg-yellow-400 transition-all duration-300"
//                 >
//                   Signup
//                 </Link>
//               </>
//             )}
//           </div>

//           {/* Mobile Menu Button */}
//           <button
//             onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//             className="md:hidden text-yellow-500 focus:outline-none ml-2"
//           >
//             <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
//             </svg>
//           </button>
//         </div>

//         {/* ---------- Mobile Menu ---------- */}
//         {isMobileMenuOpen && (
//           <div className="md:hidden bg-green-900 text-white flex flex-col px-6 py-4 space-y-3 text-sm">
//             <Link to="/" className="hover:text-yellow-400" onClick={() => setIsMobileMenuOpen(false)}>
//               Home
//             </Link>

//             <details>
//               <summary className="cursor-pointer hover:text-yellow-400">Service Areas</summary>
//               <ul className="ml-4 mt-2 space-y-2">
//                 {serviceArea.map((item, idx) => (
//                   <li key={idx}>
//                     <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)}>
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             </details>

//             <details>
//               <summary className="cursor-pointer hover:text-yellow-400">Products</summary>
//               <ul className="ml-4 mt-2 space-y-2">
//                 {products.map((item, idx) => (
//                   <li key={idx}>
//                     <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)}>
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             </details>

//             <details>
//               <summary className="cursor-pointer hover:text-yellow-400">About</summary>
//               <ul className="ml-4 mt-2 space-y-2">
//                 {aboutSection.map((item, idx) => (
//                   <li key={idx}>
//                     <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)}>
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             </details>

//             <details>
//               <summary className="cursor-pointer hover:text-yellow-400">Client Portal</summary>
//               <ul className="ml-4 mt-2 space-y-2">
//                 {user ? (
//                   <>
//                     {userProfile?.role === "user" && (
//                       <li>
//                         <Link to="/book" onClick={() => setIsMobileMenuOpen(false)}>
//                           Book Now
//                         </Link>
//                       </li>
//                     )}
//                     <li>
//                       <button onClick={handleLogoutClick}>Logout</button>
//                     </li>
//                   </>
//                 ) : (
//                   <>
//                     <li>
//                       <Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>
//                         Login
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="/register" onClick={() => setIsMobileMenuOpen(false)}>
//                         Register
//                       </Link>
//                     </li>
//                   </>
//                 )}
//               </ul>
//             </details>

//             <Link to="/contact" className="hover:text-yellow-400" onClick={() => setIsMobileMenuOpen(false)}>
//               Contact Us
//             </Link>
//           </div>
//         )}
//       </nav>
//     </>
//   );
// }

// export default Navbar;

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function Navbar({ user: initialUser, userProfile: initialUserProfile, handleLogout }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [user, setUser] = useState(initialUser || null);
  const [userProfile, setUserProfile] = useState(initialUserProfile || null);
  const navigate = useNavigate();

  const getInitials = (user) => {
    if (!user) return "";
    if (user.firstName && user.lastName)
      return user.firstName.charAt(0).toUpperCase() + user.lastName.charAt(0).toUpperCase();
    if (user.name)
      return user.name.charAt(0).toUpperCase() + user.name.charAt(user.name.length - 1).toUpperCase();
    return "";
  };

  const handleLogoutClick = () => {
    localStorage.removeItem("auth");
    setUser(null);
    setUserProfile(null);
    if (handleLogout) handleLogout();
    navigate("/login");
  };

  useEffect(() => {
    const auth = localStorage.getItem("auth");
    if (auth) {
      try {
        const parsed = JSON.parse(auth);
        const storedUser = parsed?.user;
        if (storedUser) {
          setUser(storedUser);
          setUserProfile(storedUser);
        }
      } catch (error) {
        console.error("Invalid auth data:", error);
      }
    }
  }, []);

  const serviceArea = [
    { name: "Hayes", url: "/hayes" },
    { name: "Hunslow", url: "/hunslow" },
    { name: "Southall", url: "/southall" },
    { name: "Uxbridge", url: "/uxbridge" },
    { name: "Greenford", url: "/greenford" },
    { name: "Northolt", url: "/northolt" },
    { name: "Windsor", url: "/windsor" },
    { name: "Ruislip", url: "/ruislip" },
    { name: "Harrow", url: "/harrow" },
    { name: "Maidenhead", url: "/maidenhead" },
    { name: "High Wycombe", url: "/highwycombe" },
  ];

  const aboutSection = [
    { name: "FAQs", url: "/faq" },
    { name: "Blog", url: "/blog" },
    { name: "Terms & Conditions", url: "/termsandconditions" },
  ];

  const products = [
    { name: "Blinds", url: "/blinds" },
    { name: "Carpets", url: "/carpets" },
    { name: "Furniture", url: "/furniture" },
    { name: "Sofa", url: "/sofa" },
  ];

  const clientPortal = user
    ? [
      userProfile?.role === "user" ? { name: "Book Now", url: "/book" } : null,
      { name: "Logout", action: handleLogoutClick },
    ].filter(Boolean)
    : [
      { name: "Login", url: "/login" },
      { name: "Register", url: "/register" },
    ];

  const navLinks = [
    { name: "Service Areas", dropdown: serviceArea },
    { name: "Products", dropdown: products },
    { name: "About", dropdown: aboutSection },
    { name: "Client Portal", dropdown: clientPortal },
    { name: "Contact Us", url: "/contact" },
  ];

  return (
    <>
      {/* Top Bar */}
      <div className="w-full bg-lime-700 text-white py-2 px-4 sm:px-8 flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0 text-xs sm:text-sm md:text-base font-semibold tracking-wide font-heading">
        <div className="flex items-center gap-3">
          {/* <a
      href="https://wa.me/447405264139"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 hover:opacity-90 transition"
      aria-label="Call or WhatsApp"
    >
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M22 16.92V21a1 1 0 0 1-1.11 1 19 19 0 0 1-8.63-3.07 19 19 0 0 1-6-6A19 19 0 0 1 2 3.11 1 1 0 0 1 3 2h4.09a1 1 0 0 1 1 .75c.12.75.33 1.48.63 2.18a1 1 0 0 1-.24 1.04L7.7 8.7a15 15 0 0 0 6 6l1.72-1.72a1 1 0 0 1 1.04-.24c.7.3 1.43.51 2.18.63a1 1 0 0 1 .75 1V21z"></path>
      </svg>
      <span className="leading-none">+44 7405 264139</span>
    </a> */}


        </div>

        <div className="flex items-center gap-3">
          <span className="text-sm text-white/90">Serving Greater London Area</span>
          <a href="/contact" className="ml-2 inline-flex items-center px-2 py-2 bg-white text-lime-700 rounded text-xs font-medium shadow-sm hover:opacity-95 transition">
            Get a Quote
          </a>
        </div>
      </div>

      {/* Navbar */}
      <nav className="w-full bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto flex justify-between items-center px-4 sm:px-6 md:px-8">
          {/* Logo */}
          {/* <Link to="/" className="flex items-center space-x-3">
            <div className="w-10 h-10 sm:w-14 sm:h-14 md:w-16 md:h-16 relative">
              <img src="/images/Mfblind.jpg" alt="Logo" className="w-full h-full p-1 rounded-full border-2 border-lime-500 object-cover shadow-md" />
              <div className="absolute inset-0 rounded-full ring-2 ring-lime-400 opacity-20"></div>
            </div>
            <span className="font-extrabold text-sm sm:text-lg md:text-3xl text-lime-500 tracking-wider drop-shadow-md">
              MF Blind
            </span>
          </Link> */}

          <Link to="/" className="flex items-center space-x-3">
          <img
    src="/images/logi.png"
              // 💡 RESPONSIVE CLASSES: 
              // Default width (mobile first) is w-24, increasing at sm, md, and lg breakpoints.
              className="w-28 h-28 object-contain"
            />
            {/* <div className="absolute inset-0 "></div> */}
            {/* </div> */}
          </Link>

          {/* Desktop Menu */}
          <ul className="hidden md:flex space-x-6 lg:space-x-8 items-center mx-auto text-sm md:text-base lg:text-lg">
            {navLinks.map((link, idx) => (
              <li key={idx} className="relative group">
                {link.dropdown ? (
                  <>
                    <button className="text-gray-900 hover:text-lime-500 font-medium flex items-center gap-1 transition-all duration-300">
                      {link.name}
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    <ul className="absolute top-full left-0 hidden group-hover:block bg-white border border-lime-500 shadow-lg rounded-md w-44 z-50">
                      {link.dropdown.map((item, id) => (
                        <li key={id}>
                          {item.url ? (
                            <Link
                              to={item.url}
                              className="block px-4 py-2 text-sm text-gray-900 hover:bg-lime-500 hover:text-white transition-all duration-300"
                            >
                              {item.name}
                            </Link>
                          ) : (
                            <button
                              onClick={item.action}
                              className="w-full text-left px-4 py-2 text-sm text-gray-900 hover:bg-lime-500 hover:text-white transition-all duration-300"
                            >
                              {item.name}
                            </button>
                          )}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link to={link.url} className="text-gray-900 hover:text-lime-500 font-medium transition-all duration-300">
                    {link.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>

          {/* Right Side (Mobile Hamburger and Profile) */}
          <div className="flex items-center space-x-2 sm:space-x-3">
            {user ? (
              <Link to="/profile" className="flex items-center justify-center">
                {userProfile?.avtar ? (
                  <img src={userProfile.avtar} alt="Profile" className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-full border-2 border-lime-500 object-cover" />
                ) : (
                  <div className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full border-2 border-lime-500 bg-lime-500 text-white font-bold text-xs sm:text-sm md:text-base">
                    {getInitials(userProfile || user)}
                  </div>
                )}
              </Link>
            ) : (
              <>
                <Link to="/login" className="px-2 sm:px-3 py-1 sm:py-2 text-xs sm:text-sm md:text-base rounded-md text-black border border-lime-500 hover:bg-lime-500 hover:text-gray-900 transition-all duration-300">
                  Login
                </Link>
                <Link to="/register" className="px-2 sm:px-3 py-1 sm:py-2 text-xs sm:text-sm md:text-base rounded-md bg-lime-500 text-gray-900 hover:bg-lime-400 transition-all duration-300">
                  Signup
                </Link>
              </>
            )}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-lime-500 focus:outline-none ml-2"
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white text-gray-900 flex flex-col px-6 py-4 space-y-3 text-sm sm:text-base">
            {navLinks.map((link, idx) => (
              <div key={idx}>
                {link.dropdown ? (
                  <details>
                    <summary className="cursor-pointer hover:text-lime-500">{link.name}</summary>
                    <ul className="ml-4 mt-2 space-y-2">
                      {link.dropdown.map((item, i) => (
                        <li key={i}>
                          {item.url ? (
                            <Link to={item.url} onClick={() => setIsMobileMenuOpen(false)}>
                              {item.name}
                            </Link>
                          ) : (
                            <button onClick={item.action}>{item.name}</button>
                          )}
                        </li>
                      ))}
                    </ul>
                  </details>
                ) : (
                  <Link to={link.url} className="hover:text-lime-500" onClick={() => setIsMobileMenuOpen(false)}>
                    {link.name}
                  </Link>
                )}
              </div>
            ))}
          </div>
        )}
      </nav>
    </>
  );
}

export default Navbar;
